
import loginApi from "../../api/loginApi";
import mergeDeep from "../../util/mergeDeep.js";
import transactionApi from "../../api/transactieApi";
import { TransactionDomainEnum, UserTypes } from "../../constants/DomainConstants";

export default class LoginPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        const props = context.props;
        let title = "";

        if (props.isNew) {
            title = "Meld nieuwe sportclub";
        }
        else {
            title = "Wijzig sportorganisatie";
        }

        if (!props.gebruikersnaam && !props.gebruikersEmailAdres) {
            props.setActiveUser().then(() => {
                const props = context.props;
                const model = { voornaam: props.gebruikersnaam ? props.gebruikersnaam.split(" ")[0] : "", naam: props.gebruikersnaam ? props.gebruikersnaam.replace(props.gebruikersnaam.split(" ")[0], "").trim() : "", emailAdres: props.gebruikersEmailAdres };
                context.setState({
                    model,
                    userLoggedIn: !!model.naam && !!model.voornaam,
                    title
                });
            });
        }
        else {
            const model = { voornaam: props.gebruikersnaam ? props.gebruikersnaam.split(" ")[0] : "", naam: props.gebruikersnaam ? props.gebruikersnaam.replace(props.gebruikersnaam.split(" ")[0], "").trim() : "", emailAdres: props.gebruikersEmailAdres };
            context.setState({
                model,
                userLoggedIn: !!model.naam && !!model.voornaam,
                title
            });
        }

        this.context.props.setUserType(UserTypes.WEBSITEBEZOEKER);
    }

    change(event) {
        const value = event.target.value;
        const property = event.target.name;
        const context = this.context;
        const state = context.state;

        const model = mergeDeep({}, state.model);
        model[property] = value;

        context.setState({
            model,
            voornaamHasFocus: false
        });
    }

    redirectToOrganisatiePage() {
        const context = this.context;
        const props = context.props;
        const state = context.state;
        const ajaxActions = props.ajaxActions;
        const model = state.model;
        const modelToValidate = { gebruikersnaam: model.voornaam + " " + model.naam, email: model.emailAdres, naam: model.naam, voornaam: model.voornaam };

        ajaxActions.started();

        loginApi.validate(modelToValidate)
            .then((response) => {
                loginApi.set(modelToValidate).then(() => {
                    ajaxActions.ended();

                    if (Object.keys(response.data.validationResults).length === 0) {
                        if (props.isNew) {
                            this.redirector.goTo("/nieuwesportclub/organisatie");
                        }
                        else {
                            if (!props.activeSportclubId) {
                                const params = props.match.params;
                                const poId = params.poId;

                                props.setActiveSportclub(poId, null, false, false);
                            }

                            transactionApi.getNewTransactie(TransactionDomainEnum.SPORTORGANISATIE, this.context.props.activeSportclubId)
                                .then((response) => {
                                    ajaxActions.ended();

                                    this.redirectToEditSportclub(this.context.props.activeSportclubId, response.data, false, false);
                                })
                                .catch((ex) => {
                                    ajaxActions.failed();
                                });
                        }
                    }

                    const errors = response.data.validationResults;
                    const item = response.data.item;
                    const model = { voornaam: item.voornaam ? item.voornaam : "", naam: item.naam ? item.naam : "", emailAdres: item.email };

                    context.setState({
                        model,
                        errors
                    });
                })
                    .catch((ex) => {
                        ajaxActions.failed();
                        context.props.throwException(ex, true);
                    });
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex, true);
            });
    }

    redirectToEditSportclub(id, transactieId, isNew, isReadonly) {
        const context = this.context;
        context.props.setActiveSportclub(id, transactieId, isReadonly, isNew);
        this.redirector.goTo(`/sportOrganisatie/organisatie/${transactieId}`);
    }
}